import { defineComponent } from 'navigation-components/platform/models';
import { QUARTER_IN_REVIEW_MODAL_COMPONENT, Tags } from '../constants';
import { getPortalId, waitForElement } from '../../common/utils';
import { capabilities } from '../../capabilities';
import { quarterInReviewIframeStyle } from './internal/styles';
import { args } from '../../common/args';
export const QUARTER_IN_REVIEW_MODAL_ID = 'quarter-in-review-modal';
export const quarterInReviewModalComponentDef = defineComponent(QUARTER_IN_REVIEW_MODAL_COMPONENT, {
  name: QUARTER_IN_REVIEW_MODAL_COMPONENT,
  path: `/quarter-in-review/${getPortalId()}/nav`,
  capabilities: [capabilities.RESTYLE_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.SHOW_COMPONENT_CAP.getName()],
  tags: [Tags.MODAL],
  iframeProps: {
    id: 'quarter-in-review-modal-iframe',
    ['data-test-id']: 'quarter-in-review-modal-iframe',
    style: quarterInReviewIframeStyle
  },
  renderTo: () => waitForElement(`#${QUARTER_IN_REVIEW_MODAL_ID}`),
  propsSchema: {
    source: args.string()
  },
  initialProps: {
    source: ''
  }
});